import api from "../instance/axios_instance.ts";
import { UserInterface } from "../interface/userInterface.ts";

const InfoUsersApi = async ( office_id: number): Promise<UserInterface> => {

    try {
        const response = await api.get<UserInterface>('/users', {
            params: { office_id }
        });
        
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError);
    }

}

export default InfoUsersApi;